export default __webpack_public_path__ + "assets/2ccede13fd22bcfcdb73df0474c44b41.svg";